import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import TokenAllocationChart from "./TokenAllocationChart";
import InvestorTierChart from "./InvestorTierChart";
import Web3 from "web3";
import Token from '../../abi/Ptgc.json';
import Staking from '../../abi/Staking.json';
import { sendGetRequest, providerURL } from '../../../../helper/Helper'; 

const TokenDistributionModal = ({ modalIsOpen, closeModal, ptgcPrice}) => {
    const [pTGCBurned, setPTGCBurned] = useState(0);
    const [pTGCLiquidity, setPTGCLiquidity] = useState(0);
    const [pTGCLiquidityUSD, setPTGCLiquidityUSD] = useState(0);
    const [pTGCStake, setPTGCStake] = useState(0);
    const [pTGCLock, setPTGCLock] = useState(0);
    const [pTGCHold, setPTGCHold] = useState(0);
    const [pTGCOldPrice, setPTGCOldPrice] = useState(0);

    const [pieData, setPieData] = useState([
      { id: 0, value: 0, name: "Poseidon", supply: 0, marketCap: 0, positionSize: 33333333333, color: "url(#a1)", img: "./images/poseidon.png" },
      { id: 1, value: 0, name: "Whale", supply: 0, marketCap: 0, positionSize: 3333333333, color: "url(#a2)", img: "./images/whale.png" },
      { id: 2, value: 0, name: "Shark", supply: 0, marketCap: 0, positionSize: 333333333, color: "url(#a3)", img: "./images/shark.png" },
      { id: 3, value: 0, name: "Dolphin", supply: 0, marketCap: 0, positionSize: 33333333, color: "url(#a4)", img: "./images/dolphin.png" },
      { id: 4, value: 0, name: "Squid", supply: 0, marketCap: 0, positionSize: 3333333, color: "url(#a5)", img: "./images/squid.png" },
      { id: 5, value: 0, name: "Turtle", supply: 0, marketCap: 0, positionSize: 333333, color: "url(#a1)", img: "./images/turtle.png" },
      { id: 6, value: 0, name: "Crab", supply: 0, marketCap: 0, positionSize: 33333, color: "url(#a2)", img: "./images/crab.png" },
      { id: 7, value: 0, name: "Shrimp", supply: 0, marketCap: 0, positionSize: 3333, color: "url(#a3)", img: "./images/shrimp.png" },
    ]);

    const handleModalOpen = async () => {
      try {
        await getAllocationData();
        const response = await sendGetRequest('holders/tags/counts');
        if (response && response.status === 200 && Array.isArray(response.data)) {
          setPTGCOldPrice(response.meta.last_month_price);
          const updated = pieData.map(item => {
            const match = response.data.find(d => d.tag.toLowerCase() === item.name.toLowerCase());
            if (match) {
              return {
                ...item,
                value: match.cnt,
                supply: match.total_value,
                marketCap: match.total_value * ptgcPrice,
                label: `${item.name}\nSupply: ${match.cnt}\nMarket Cap: ${match.total_value.toLocaleString()}`
              };
            }
            return item;
          });
          setPieData(updated);
        }
      } catch (error) {}
    };

    const getAllocationData = async () => {
      const web3 = new Web3(providerURL());
      const pTGCContract = new web3.eth.Contract(Token.ABI, Token.Contract);
      const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);

      let burned = parseInt(await pTGCContract.methods.balanceOf('0x0000000000000000000000000000000000000369').call()) / 10**18;
      let locked = parseInt(await stakingContract.methods.totalLocked().call()) / 10**18;
      let staked = parseInt(await stakingContract.methods.totalStaked().call()) / 10**18;
      let liquidityData = await getLiquidityData();

      setPTGCBurned(burned);
      setPTGCStake(staked - locked);
      setPTGCLock(locked);
      setPTGCLiquidity(liquidityData.pTGCLiquidity);
      setPTGCHold(333333333333 - (burned + staked + liquidityData.pTGCLiquidity));
      setPTGCLiquidityUSD(liquidityData.USDLiquidity);
    }

    const getLiquidityData = async () => {
      try {
        const response = await sendGetRequest('pairs-volumes/latest/all');
        if (response && response.status === 200) {
          let pTGCLiquidity = 0;
          let USDLiquidity = 0;

          response.data.forEach(pair => {
            if (pair.pair.base_symbol === "pTGC") 
            {
              pTGCLiquidity += parseFloat(pair.base_liquidity);
              USDLiquidity += pair.liquidity;
            } 
            else if (pair.pair.qoute_symbol === "pTGC") 
            {
              pTGCLiquidity += parseFloat(pair.quote_liquidity);
              USDLiquidity += pair.liquidity;
            }
          });
         return { pTGCLiquidity, USDLiquidity };
        }
      } catch (error) {}
    }
    
    const PercentChange = ({ current, previous }) => {
      if (previous === 0) return <span className="updown up"><i className="fa-solid fa-arrow-up"></i>0.00</span>;
      const change = ((current - previous) / previous) * 100;
      const isUp = change >= 0;
      return (
        <div style={{ fontSize: "18px", fontWeight: "bold" }}>
          {isUp ? (
            <span className="updown up"><i className="fa-solid fa-arrow-up"></i>{change.toFixed(2)}%</span>
          ) : (
            <span className="updown down"><i className="fa-solid fa-arrow-down"></i>{change.toFixed(2)}%</span>
          )}
        </div>
      );
    };

    return (
      <>
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal" onAfterOpen={handleModalOpen}>
          <div className="My__Overlay">
            <div className="My__OverlayIn">
              <div className="PTGCSEC popupcenter">
                <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal} >
                  <span className="underline">Close</span>
                  <img src="./images/XCircle.svg" className="img-fluid" alt="Close" />
                </button>
                <div className="container">
                  <div className="text-center">
                    <h2 className="mb-0 mt-2 w-100 good_times goldFont">Token Distribution</h2>
                  </div>
                  <div className="subcontent subPad mt-4">
                    <div className='mb-4 text-center'>
                      <div className="row justify-content-center">
                        <div className="col-lg-6">
                          <TokenAllocationChart pTGCBurned={pTGCBurned} pTGCLiquidity={pTGCLiquidity} pTGCStake={pTGCStake} pTGCLock={pTGCLock} pTGCHold={pTGCHold} ptgcPrice={ptgcPrice}/>
                          <h2 className="h2Dcolor">PTGC Token Allocation</h2>
                          <div className=" text-center">
                            <p className="w-100 mx-auto">
                              The Token Distribution outlines how the total supply of tokens is allocated among stakeholders to ensure fairness, sustainability, and growth.
                            </p>
                          </div>
                        </div>
                        {/*<div className="col-lg-6">
                          <div className="d-flex justify-content-center align-items-center">
                            <InvestorTierChart poseidon={pieData[0].supply} whale={pieData[1].supply} shark={pieData[2].supply} dolphin={pieData[3].supply} squid={pieData[4].supply} turtle={pieData[5].supply} crab={pieData[6].supply} shrimp={pieData[7].supply}/>
                          </div>
                          <h2 className="h2Dcolor">Investor Tier Breakdown</h2>
                          <div className=" text-center">
                            <p className="w-100 mx-auto">Each allocation serves a strategic purpose in supporting the ecosystem and incentivizing long-term commitment.
                            </p>
                          </div>
                        </div>*/}
                      </div>
                    </div>

                  <div className="RewardsSec greysubcontent subcontent subPad p-3 px-3">
                    <div className="relative">
                      <div className="row align-items-center">
                        <div className="col-xl-12"  data-aos="fade-up"  data-aos-delay="600" data-aos-duration="1400">
                            <div className="row ">
                              <div className="col-md-6 col-xl-4">
                                <div className="boxes2 p-0 mb-2 freesMulti">
                                  <div className="result-single">
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>PTGC  Burned</span>
                                    </div>
                                    <h3 className="dollorValue value">
                                      <span className="dollor">$</span>
                                      <span>{parseFloat(pTGCBurned * ptgcPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                    </h3> 
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>{parseFloat(pTGCBurned).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </span>
                                      <span className="dot"></span>
                                      <span>PTGC</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 col-xl-4">
                                <div className="boxes2 p-0 mb-2 freesMulti">
                                  <div className="result-single">
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>PTGC Liquidity</span>
                                    </div>
                                    <h3 className="dollorValue value">
                                      <span className="dollor">$</span>
                                      <span>{parseFloat(pTGCLiquidityUSD).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                    </h3> 
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>{parseFloat(pTGCLiquidity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </span>
                                      <span className="dot"></span>
                                      <span>PTGC</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 col-xl-4">
                                <div className="boxes2 p-0 mb-2 freesMulti">
                                  <div className="result-single">
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>PTGC Hold</span>
                                    </div>
                                    <h3 className="dollorValue value">
                                      <span className="dollor">$</span>
                                      <span>{parseFloat(pTGCHold * ptgcPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                    </h3> 
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>{parseFloat(pTGCHold).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                      <span className="dot"></span>
                                      <span>PTGC</span>
                                    </div>
                                  </div>
                                </div>
                              </div>


                              <div className="col-md-6 col-xl-4">
                                <div className="boxes2 p-0 mb-2 freesMulti">
                                  <div className="result-single">
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>PTGC Staked</span>
                                    </div>
                                    <h3 className="dollorValue value">
                                      <span className="dollor">$</span>
                                      <span>{parseFloat(pTGCStake * ptgcPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                    </h3> 
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>{parseFloat(pTGCStake).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                      <span className="dot"></span>
                                      <span>PTGC</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 col-xl-4">
                                <div className="boxes2 p-0 mb-2 freesMulti">
                                  <div className="result-single">
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>PTGC Staked & Locked</span>
                                    </div>
                                    <h3 className="dollorValue value">
                                      <span className="dollor">$</span>
                                      <span>{parseFloat(pTGCLock * ptgcPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                    </h3> 
                                    <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                                      <span>{parseFloat(pTGCLock).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                      <span className="dot"></span>
                                      <span>PTGC</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="whahesHere mt-2">
                    <div className="row">
                      {pieData.map(item => (
                        <div className="col-lg-3" key={item.id}>
                          <div className="subcontent subPad SRTOP p-0 mt-3 mb-0">
                            <div className="minheightLeagues2">
                              <div className="snstakes statsALL" style={{ border: "0px" }}>
                                <div className="relative minheightAuto">
                                  <div className="t">
                                    <div className="iconiconSR">
                                      <img style={{padding: '8px 8px', lineHeight: '0px',     filter: 'grayscale(1)'}}
                                        className="img-fluid"
                                        src={item.img}
                                        alt={item.name}
                                      />
                                    </div>
                                    <div className="statBottom" style={{ paddingTop: "25px" }}>
                                      <h2 className="fHead">{item.name}</h2>
                                       <div className="perVal fInter d-flex align-items-center">
                                        <span>Holder</span>
                                        <span className="dot"></span>
                                        <span>{parseFloat(item.value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0})}</span>
                                      </div>
                                      <div className="perVal fInter d-flex align-items-center">
                                        <span>Supply</span>
                                        <span className="dot"></span>
                                        <span>{parseFloat(item.supply).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                                      </div>
                                      <div className="perVal fInter d-flex align-items-center">
                                        <span>Market Cap</span>
                                        <span className="dot"></span>
                                        <span>${parseFloat(item.marketCap).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                                      </div>
                                      <div className="perVal fInter d-flex align-items-center">
                                        <span>PTGC Req.</span>
                                        <span className="dot"></span>
                                        <span>{parseFloat(item.positionSize).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                                      </div>
                                      <div className="perVal fInter d-flex align-items-center">
                                        <span>Rank Cost</span>
                                        <span className="dot"></span>
                                        <span>${parseFloat(item.positionSize * ptgcPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                                      </div>
                                      <div className="perVal fInter d-flex align-items-center">
                                        <span>Change in 30 Days</span>
                                        <span className="dot"></span>
                                        <PercentChange current={item.positionSize * ptgcPrice} previous={item.positionSize * pTGCOldPrice} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TokenDistributionModal;
